import { format, isValid } from 'date-fns';
import { CalendarDays, Clock2, Phone, Video } from 'lucide-react';

import { NEW_PATIENT_VISIT_DURATION_IN_MINUTES } from '@/lib/constants';
import type { Appointment } from '@/types/order.type.ts';

type AppointmentCardProps = {
  appointment: Appointment;
  isPhoneCall: boolean;
};

export default function AppointmentCard({ appointment, isPhoneCall }: AppointmentCardProps) {
  const durationInMinutes = appointment.durationInMinutes ?? NEW_PATIENT_VISIT_DURATION_IN_MINUTES;

  return (
    <div className="bg-spruce-50 border-spruce-300 space-y-2 rounded-sm border px-4 py-3">
      <h3 className="text-md font-medium">Appointment Details</h3>

      {appointment.scheduledTime && isValid(appointment.scheduledTime) && (
        <div className="flex items-center gap-2">
          <CalendarDays className="size-4" />
          <p className="text-sm">{format(appointment.scheduledTime, "EEE MMM. d 'at' h:mmaaa")}</p>
        </div>
      )}

      <div className="flex items-center gap-2">
        <Clock2 className="size-4" />
        <p className="text-sm">{durationInMinutes} minutes</p>
      </div>

      {isPhoneCall ? (
        <div className="flex items-center gap-2">
          <Phone className="size-4" />
          <p className="text-sm">A provider will call you at the time of your appointment.</p>
        </div>
      ) : (
        <div className="flex items-center gap-2">
          <Video className="size-4" />
          <p className="text-sm">Video visit—link sent to email / SMS</p>
        </div>
      )}
    </div>
  );
}
